import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox viewBox="0 12 64 40" {...props}>
    <path d="M31.75 12.75L63.75 44.75L57.25 51.25L31.75 25.75L6.25 51.25L-0.25 44.75L31.75 12.75Z" />
  </IconBox>
);
